import close from '@/assets/imgs/icon/close.png'
import exitFullScreen from '@/assets/imgs/icon/exit-full-screen.png'
import enterFullScreen from '@/assets/imgs/icon/enter-full-screen.png'
import closeOutline from '@/assets/imgs/icon/close-outline.png'
import arrowRight from '@/assets/imgs/icon/arrow-right.png'
import play from '@/assets/imgs/icon/play.png'
import barChart from '@/assets/imgs/icon/bar-chart.png'
import smiley from '@/assets/imgs/icon/smiley.png'
import successFilled from '@/assets/imgs/icon/success-filled.png'
import warningFilled from '@/assets/imgs/icon/warning-filled.png'
import playWrong from '@/assets/imgs/icon/play-wrong.png'
import bellOutline from '@/assets/imgs/icon/bell-outline.png'
import time from '@/assets/imgs/icon/time.png'
import moodEmpty from '@/assets/imgs/icon/mood-empty.png'
import eyeOutline from '@/assets/imgs/icon/eye-outline.png'
import eye from '@/assets/imgs/icon/eye.png'
import numberMaster from '@/assets/imgs/icon/number-master.png'
import lockLight from '@/assets/imgs/icon/lock-light.png'
import user from '@/assets/imgs/icon/user.png'
import phone from '@/assets/imgs/icon/phone.png'
import arrowUp from '@/assets/imgs/icon/arrow-up.png'
import arrowDown from '@/assets/imgs/icon/arrow-down.png'
import time_gray from '@/assets/imgs/icon/time_gray.png'
import warning_gray from '@/assets/imgs/icon/warning_gray.png'
import liveing_green from '@/assets/imgs/icon/liveing_green.png'
import playing_green from '@/assets/imgs/icon/playing_green.png'
import playback_green from '@/assets/imgs/icon/playback_green.png'
import tousu from '@/assets/imgs/icon/tousu.png'
import tousuWhite from '@/assets/imgs/icon/tousuWhite.png'
import person1 from '@/assets/imgs/person1.png'
import person2 from '@/assets/imgs/person2.png'
import notice from '@/assets/imgs/icon/notice.png'

const imgs: any = {
  'close': close,
  'exit-full-screen': exitFullScreen,
  'enter-full-screen': enterFullScreen,
  'close-outline': closeOutline,
  'arrow-right': arrowRight,
  'play': play,
  'bar-chart': barChart,
  'smiley': smiley,
  'success-filled': successFilled,
  'warning-filled': warningFilled,
  'play-wrong': playWrong,
  'bell-outline': bellOutline,
  'time': time,
  'mood-empty': moodEmpty,
  'eye-outline': eyeOutline,
  'eye': eye,
  'number-master': numberMaster,
  'lock-light': lockLight,
  'user': user,
  'phone': phone,
  'arrow-up': arrowUp,
  'arrow-down': arrowDown,
  'time_gray': time_gray,
  'warning_gray': warning_gray,
  'liveing_green': liveing_green,
  'playing_green': playing_green,
  'playback_green': playback_green,
  'tousu': tousu,
  'person1': person1,
  'person2': person2,
  'notice': notice,
  'tousuWhite': tousuWhite
}

/** 预加载图片 */
export const initImgIcon = async (arr: any = Object.keys(imgs)) => {
  const error: any = []
  const TIMEOUT = 5000 // 设置超时时间为5秒

  const loadImage = (key: any) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.src = imgs[key]

      const timeoutId = setTimeout(() => {
        img.onerror = null // 清除错误处理程序
        reject(new Error('Image load timed out'))
      }, TIMEOUT)

      img.onload = () => {
        clearTimeout(timeoutId)
        resolve(true)
      }

      img.onerror = () => {
        clearTimeout(timeoutId)
        reject(new Error('Image load error'))
      }
    })
  }

  const promises = arr.map((key: any) => loadImage(key).catch(() => error.push(key)))
  await Promise.all(promises)

  if (error.length > 0) {
    setTimeout(() => {
      initImgIcon(error)
    }, 2000)
  }
}

/** 获取图片 */
export const getImg = (key: any) => {
  return new Promise(resolve => {
    if (['close', 'close-outline'].includes(key)) {
      const img = new Image()
      img.src = imgs[key]

      const timeoutId = setTimeout(() => {
        console.log('图片1')
        img.onerror = null // 清除错误处理程序
        resolve('')
      }, 5000)

      img.onload = () => {
        console.log('图片2')
        clearTimeout(timeoutId)
        resolve(imgs[key])
      }

      img.onerror = () => {
        console.log('图片3')
        clearTimeout(timeoutId)
        resolve('')
      }
    } else {
      resolve(imgs[key])
    }
  })
}
